import React from 'react'
import { Routes, Route } from 'react-router-dom'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import Seo from './components/Seo'
import Home from './pages/Home'
import Galleria from './pages/Galleria'
import Contatti from './pages/Contatti'
import InfoEvento from './pages/InfoEvento'
import NotFound from './pages/NotFound'

function App() {
  return (
    <>
      <Seo />
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/galleria" element={<Galleria />} />
          <Route path="/info" element={<InfoEvento />} />
          <Route path="/contatti" element={<Contatti />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </>
  )
}

export default App
